import React, { useState, useEffect, useContext } from "react";
import {
  Typography,
  Box,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
} from "@mui/material";
import RoomTypeRatePlanContext from "../contexts/RoomTypeRatePlanContext";
import CheckoutContext from "../contexts/CheckoutContext";
import { format } from "date-fns";
import jsPDF from "jspdf";
import {
  obtenerImagenCabezal,
  obtenerDatosHotel,
} from "../../services/motorService";
import Cookies from "js-cookie";
import useSession from "../../services/session"; // Importar la función de sesión
import { useNavigate } from "react-router-dom"; // Para la navegación
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useLocation } from 'react-router-dom';

const ReservationSummary = () => {
  const { cartItems, reservaAdmintour } = useContext(RoomTypeRatePlanContext);
  const { setFormValues } = useContext(CheckoutContext);
  const [bannerUrl, setBannerUrl] = useState(null);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const hotcodParam = params.get('hotcod');
    const hotCod = hotcodParam ?? Cookies.get('hotCod') ?? null;
  const [datosHotel, setDatosHotel] = useState({});
  //const session = useSession(); // Obtener la sesión actual
  const navigate = useNavigate(); // Hook para navegar entre páginas
  const BASE_URL = '/MotorReservasAdmintour';
  //const BASE_URL = "/QAMotorReservasAdmintour";

  // -----------------------------------------------------------------------
  // FIX: número de reserva a mostrar, con fallback.
  //
  // reservaAdmintour viene del context y solo se setea cuando Checkout.js
  // efectivamente llama a graboReservaEnAdmintour y recibe textoreserva.
  // En el caso en que la reserva ya estaba procesada (SDT_MotorReserva
  // vino vacío desde el motor), Checkout.js corta antes de llegar a esa
  // llamada y navega directo acá sin haber seteado reservaAdmintour, así
  // que llega null/undefined.
  //
  // Como Checkout.js navega con buildUrl(), que reutiliza location.search,
  // el query param NumeroReservaMotor (el que llegó desde el redirect de
  // WebPay) sigue presente en la URL cuando entramos a esta pantalla. Lo
  // usamos como referencia de respaldo para no dejar al cliente sin ningún
  // número, y sobre todo para no romper el .split(" ")[0] cuando
  // reservaAdmintour es null.
  //
  // Ojo: NumeroReservaMotor es el número interno del motor de reservas,
  // no necesariamente el mismo número/formato que usa Admintour. Es un
  // parche para no crashear y darle algo útil al cliente; si el backend
  // llega a poder devolver el número real de Admintour en este escenario
  // (por ejemplo agregándolo también a la URL de retorno, o vía un
  // endpoint de consulta), convendría reemplazar este fallback por ese
  // valor real.
  // -----------------------------------------------------------------------
  const numeroReservaMotorParam = params.get('NumeroReservaMotor');
  const numeroReservaMostrado = reservaAdmintour
    ? reservaAdmintour.split(" ")[0]
    : (numeroReservaMotorParam || "");

    const handleSeguirComprando = () => {
        localStorage.removeItem("sessionData");
        navigate(`${BASE_URL}/disponibilidad/habitaciones?hotcod=${hotCod}`);
        window.location.reload();  // Recargar la página para que la sesión se reinicie

    };

  useEffect(() => {
    const fetchBannerImage = async () => {
      try {
        const imagenBase64 = await obtenerImagenCabezal(hotCod);
        if (
          !imagenBase64.startsWith("Imagen del Cabezal Sin Datos para el hotel")
        ) {
          setBannerUrl(`data:image/png;base64,${imagenBase64}`);
        }
      } catch (error) {
        console.error("Error fetching header image:", error);
      }
    };

    fetchBannerImage();
  }, []);
  useEffect(() => {
    // Resetear los valores del formulario cuando se entra a la página de resumen
    setFormValues({
      motorreservanombretitular: "",
      motorreservaapellidotitular: "",
      reservanombre: "",
      reservatipodocumento: "",
      reservadocumento: "",
      reservatelefono: "",
      correoElectronico: "",
      reservadireccion: "",
      reservafechanacimiento: null,
      reservapais: "",
      reservaobservaciones: "",
      reservaautocolor: "",
      reservaautomarca: "",
      reservaautomatricula: "",
    });

    // Limpiar el `localStorage` para evitar datos almacenados en sesiones previas
    localStorage.removeItem("checkoutForm");
  }, [setFormValues]);

  const formatTitleDate = () => {
    if (cartItems && cartItems.length > 0) {
      const checkinDate = new Date(cartItems[0].CarritoItemDesde);
      const checkoutDate = new Date(cartItems[0].CarritoItemHasta);

      const checkinDay = checkinDate.getUTCDate();
      const checkinMonth = checkinDate.getUTCMonth() + 1;
      const checkinYear = checkinDate.getUTCFullYear();
      const fullcheckinData =
        checkinDay + "/" + checkinMonth + "/" + checkinYear;

      const checkoutDay = checkoutDate.getUTCDate();
      const checkoutMonth = checkoutDate.getUTCMonth() + 1;
      const checkoutYear = checkoutDate.getUTCFullYear();
      const fullcheckoutData =
        checkoutDay + "/" + checkoutMonth + "/" + checkoutYear;
        return (
          <>
            Su reserva es la número <strong>{numeroReservaMostrado || "—"}</strong> con fecha de Checkin <strong>{fullcheckinData}</strong> y fecha de Checkout <strong>{fullcheckoutData}</strong>
          </>
        );

    }
    return "";
  };

  const totalImporte = cartItems
    ? cartItems.reduce(
        (total, item) => total + parseFloat(item.CarritoItemTotal || 0),
        0
      )
    : 0;

  const obtengoCarritoMoneda = (carrito) => {
    if (carrito && carrito.length > 0) {
      return carrito[0].CarritoItemMoneda;
    }
    return "";
  };
  const getData = async () => {
    try {
      const data = await obtenerDatosHotel(hotCod); // Usa hotCod en la llamada a la API
      setDatosHotel(data);
    } catch (error) {
      console.error("Error fetching hotel data:", error);
    }
  };
  getData();
  const generatePDF = async () => {
    const doc = new jsPDF();
    const pageHeight = doc.internal.pageSize.height; // Altura de la página
    // Añadir la imagen en el encabezado (posición x=10, y=10, ancho=50, alto=20)
    doc.addImage(bannerUrl, "JPEG", 0, 10, 210, 40);
    let y = 60; // Ajustamos la posición después de la imagen
    // Título
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    const nombreCarta = datosHotel.TituloCarta;
    doc.text(nombreCarta, 20, y);
    doc.setFont("helvetica", "normal");
    y += 10;

    // Texto introductorio ajustado al ancho
    doc.setFontSize(12);
    const introText = datosHotel.MotorHotTextoConf;
    const splitIntroText = doc.splitTextToSize(introText, 180);
    splitIntroText.forEach((line) => {
      if (y > pageHeight - 20) {
        // Verificar si se necesita un salto de página
        doc.addPage();
        y = 20; // Reiniciar `y` para la nueva página
      }
      doc.text(line, 20, y);
      y += 6;
    });
    y += 10;
    // Detalle de las habitaciones
    doc.setFont("helvetica", "bold");
    doc.text(
      `Detalle de habitaciones reservadas para la reserva número  ${numeroReservaMostrado}`,
      20,
      y
    );
    doc.setFont("helvetica", "normal");

    // Desglose del detalle de habitaciones
    for (const item of cartItems) {
      //handleChartDetail(item.CarritoItemLinea);
      //const detail = await obtenerDetalleCarrito(hotCod, session, item.CarritoItemLinea);
      //console.log("DETAIL:", detail);
      y += 10;
      if (y > pageHeight - 20) {
        doc.addPage();
        y = 20;
      }
      doc.setFont("helvetica", "bold");
      doc.text(
        `Período de la reserva de la habitación ${item.CarritoItemLinea}:`,
        20,
        y
      );
      doc.setFont("helvetica", "normal");
      y += 10;
      doc.text(`Check-in: ${item.CarritoItemDesde}`, 20, y);
      doc.text(`Check-out: ${item.CarritoItemHasta}`, 120, y); // Alineado en dos columnas
      y += 10;
      doc.text(`Tipo de Habitación: ${item.CarritoItemTipoHab}`, 20, y);
      y += 10;
      doc.text(`Tarifa contratada: ${item.CarritoItemTarifa}`, 20, y);
      doc.text(
        `Adultos: ${item.CarritoItemMayores}, Menores: ${item.CarritoItemMenores}`,
        120,
        y
      );
      y += 10;
      if (y > pageHeight - 20) {
        doc.addPage();
        y = 20;
      }

      doc.text(
        `Total de la habitación: ${item.CarritoItemMoneda} ${item.CarritoItemTotal}`,
        20,
        y
      );
      y += 10;
    }
    if (y > pageHeight - 20) {
      doc.addPage();
      y = 20;
    }
    y += 10;
    // Total de la estadía
    doc.setFont("helvetica", "bold");
    doc.text(
      `Total de la estadía: ${totalImporte.toFixed(2)} ${obtengoCarritoMoneda(
        cartItems
      )}`,
      20,
      y
    );
    doc.setFont("helvetica", "normal");
    y += 20;

    // Condiciones de compra
    if (y > pageHeight - 20) {
      doc.addPage();
      y = 20;
    }
    doc.setFont("helvetica", "bold");
    doc.text("Condiciones de compra:", 20, y);
    doc.setFont("helvetica", "normal");
    y += 10;
    const condicionesText = datosHotel.Condiciones;
    const splitCondicionesText = doc.splitTextToSize(condicionesText, 180);
    splitCondicionesText.forEach((line) => {
      if (y > pageHeight - 20) {
        doc.addPage();
        y = 20;
      }
      doc.text(line, 20, y);
      y += 6;
    });
    y += 10;

    // Normas del Hotel
    if (y > pageHeight - 30) {
      doc.addPage();
      y = 20;
    }
    doc.setFont("helvetica", "bold");
    doc.text("Políticas de Reserva del hotel:", 20, y);
    doc.setFont("helvetica", "normal");
    y += 10;
    const normasText = datosHotel.MotorHotNormas;
    const splitNormasText = doc.splitTextToSize(normasText, 180);
    splitNormasText.forEach((line) => {
      if (y > pageHeight - 20) {
        doc.addPage();
        y = 20;
      }
      doc.text(line, 20, y);
      y += 6;
    });
    y += 10;

    // Información del hotel
    if (y > pageHeight - 20) {
      doc.addPage();
      y = 20;
    }
    doc.setFont("helvetica", "bold");
    doc.text("Información del hotel:", 20, y);
    doc.setFont("helvetica", "normal");
    y += 10;
    doc.text(`Teléfono: ${datosHotel.MotorHotTelefono}`, 20, y);
    doc.text(`Email: ${datosHotel.MotorHotCorreo}`, 20, y + 10);
    doc.text(`Horario de atención: ${datosHotel.MotorHotHorario}`, 20, y + 20);

    // Guardar el PDF
    doc.save("confirmacion-reserva.pdf");
  };

  return (
    <Card sx={{ mt: 5 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Gracias por reservar con nosotros
        </Typography>
        <Typography variant="body1">
          A continuación le presentaremos el resumen de su reserva
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="body2" color="textSecondary">
          {formatTitleDate()}
        </Typography>
        <Divider sx={{ my: 2 }} />
        <List>
          {cartItems.map((item) => (
            <div key={item.CarritoItemLinea}>
              <ListItem alignItems="flex-start">
                <ListItemText
                  primary={
                    <>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {item.CarritoItemTipoHab}
                      </Typography>
                      <Typography variant="body1">
                        {item.CarritoItemTarifa}
                      </Typography>
                    </>
                  }
                  secondary={
                    <>
                      <Typography
                        component="div"
                        color="textSecondary"
                        sx={{ marginTop: 2 }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography variant="body2" color="textSecondary">
                            {`${item.CarritoItemMayores} adulto(s), ${item.CarritoItemMenores} menor(es)`}
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            {`${item.CarritoItemTotal.toLocaleString("es-ES", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })} ${item.CarritoItemMoneda}`}
                          </Typography>
                        </Box>
                      </Typography>
                    </>
                  }
                />
              </ListItem>
              <Divider />
            </div>
          ))}
          <Typography component="div" sx={{ marginTop: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                Total
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                {totalImporte.toFixed(2).toLocaleString("es-ES", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })} {obtengoCarritoMoneda(cartItems)}
              </Typography>
            </Box>
          </Typography>
        </List>
        <Button
  variant="contained"
  onClick={generatePDF}
  startIcon={<PictureAsPdfIcon />}
  sx={{
    mt: 2,
    mb: 2,
    fontWeight: 'bold',
    padding: '12px 24px',
    fontSize: '1rem',
    textTransform: 'none',
    backgroundColor: '#4CAF50', // Verde suave
    color: '#fff',
    '&:hover': {
      backgroundColor: '#43A047', // Un verde más oscuro al hacer hover
    },
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    mr: 2
  }}
>
  Descargar confirmación en PDF
</Button>


      </CardContent>
    </Card>
  );
};

export default ReservationSummary;